import { objectiveEvidence } from '@ebu/adaptive-engine';
import type { AttemptStoreRecord, EvidenceStoreRecord } from '../../adapters/local-store/schema';

/** Attempt and evidence records shared by the Lab (Phase 7) and the sample learners (Phase 9). */

export type LearningAttempt = Omit<AttemptStoreRecord, 'workspaceId'>;

/** Evidence for the attempt's idea, from all attempts up to and including it. */
export function evidenceFor(
  workspaceId: string,
  attempt: LearningAttempt,
  history: readonly LearningAttempt[],
): EvidenceStoreRecord {
  const upTo = history.slice(0, history.indexOf(attempt) + 1);
  const e = objectiveEvidence(attempt.objectiveId, upTo);
  const key = e.keyAttempt ? upTo.find((a) => a === e.keyAttempt) : undefined;
  return {
    id: `${workspaceId}:${attempt.objectiveId}`,
    workspaceId,
    objectiveId: attempt.objectiveId,
    source: 'circuit-game',
    status: e.status,
    reason: e.reason,
    keyAttemptId: key?.id ?? null,
    attemptCount: e.attempts.length,
    provisional: true,
    updatedAt: attempt.endedAt,
  };
}
